import { type FC, type ReactNode } from "react";

import { TooltipIndicator, TooltipPlacementTypes } from "@snapchat/snap-design-system";

import { Label } from "./Label";

interface FieldNameProps {
    label: ReactNode;
    content?: ReactNode;
    className?: string;
    dataTestId?: string;
}

export const LabelWithTooltip: FC<FieldNameProps> = ({ label, content, className, dataTestId }) => {
    return (
        <Label data-testid={dataTestId} className={className}>
            {label}
            {content && (
                <TooltipIndicator
                    content={content}
                    placement={TooltipPlacementTypes.TOP}
                    style={{ marginInlineStart: "6px" }}
                />
            )}
        </Label>
    );
};
